import React from 'react'
import PropTypes from 'prop-types'
import Link, { navigateTo, withPrefix } from 'gatsby-link'
import withStyles from '@material-ui/core/styles/withStyles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Pagination from 'rc-pagination'

const styles = (theme) => ({
  appBar: {
    background: 'none',
    boxShadow: 'none',
  },
  pagination: {
    '& > li': {
      marginBottom: 3,
      border: `1px solid ${theme.palette.borders.cloudier}`,
      borderRadius: '50%',
      background: theme.palette.primary.main,
      transition: 'background 0.5s',
      '&:hover': {
        background: theme.palette.background.light,
      },
      '& > a': {
        transition: 'color 0.5s',
        color: '#fff',
        '&:hover': {
          color: theme.palette.primary.main,
        },
      },
    },
    [theme.breakpoints.down('xs')]: {
      transform: 'scale(0.75)',
      width: '100%',
      '& > li': {
        marginRight: 2,
      },
    },
  },
})

class ArticlesPagination extends React.Component {
  state = {
    pageSize: 6,
  }

  componentDidMount = () => {
    return this.setState({ pageSize: this.props.itemsPerPage || 6 })
  }

  onPageChange = (current) => {
    const { prefix } = this.props
    const baseUrl = withPrefix(prefix)
    navigateTo(baseUrl + (current !== 1 ? `/${current}` : ''))
  }

  onShowSizeChange = (current, pageSize) => this.setState({ pageSize })

  itemRenderer = (current, type) => {
    const { prefix, currentPage } = this.props
    if (type === 'prev') {
      return <Link to={prefix + '/' + current} />
    }
    if (type === 'page') {
      return (
        <Link
          title={`Go to page: ${current}`}
          to={prefix + (current !== 1 ? `/${current}` : '')}
          style={{
            color: currentPage === current ? '#ffa800' : '#fff',
          }}
        >
          {current}
        </Link>
      )
    }
    if (type === 'next') {
      return <Link to={prefix + '/' + current} />
    }
  }

  render() {
    const { classes, currentPage, totalItems, itemsPerPage } = this.props
    const { state } = this
    return (
      <AppBar position="static" classes={{ root: classes.appBar }}>
        <Toolbar style={{ margin: 'auto', padding: 0 }}>
          <Pagination
            current={currentPage}
            total={totalItems}
            pageSize={state.pageSize}
            pageSizeOptions={['6', '12', '24', '48']}
            onChange={this.onPageChange}
            className={classes.pagination}
            itemRender={this.itemRenderer}
            onShowSizeChange={this.onShowSizeChange}
          />
        </Toolbar>
      </AppBar>
    )
  }
}

ArticlesPagination.propTypes = {
  classes: PropTypes.object.isRequired,
  currentPage: PropTypes.number.isRequired,
  totalItems: PropTypes.number.isRequired,
  itemsPerPage: PropTypes.number.isRequired,
  prefix: PropTypes.string.isRequired,
}

export default withStyles(styles)(ArticlesPagination)



// WEBPACK FOOTER //
// ./src/components/ArticlesPagination.js